const baseURL = '/ads';

async function generate(url, isAppAds = false) {
    return axios
        .post(`${baseURL}/generate`, { url, isAppAds })
        .then(R.prop('data'));
}

async function generateByMeta(data) {
    return axios.post(`${baseURL}/generate`, data).then(R.prop('data'));
}

export default {
    generate,
    generateByMeta,
};
